<template>
    <div v-if="show" class="openFinanceRedirect">
        <div class="openFinanceRedirect__container">
            <div class="openFinanceRedirect__content">
                <slot name="first">
                    <div class="openFinanceRedirect__images">
                        <img src="@/assets/img/Cielo.svg" alt="Redirecionamento Cielo" tabindex="-1" />
                        <img src="@/assets/img/Seta.svg" alt="Seta de Redirecionamento" tabindex="-1" />
                        <img :src="selectedBank.customerFriendlyLogoUri" :alt="'Redirecionamento ' + selectedBank.organizationName" tabindex="-1" />
                    </div>
                </slot>
                <slot name="second">
                    <h2 class="openFinanceRedirect__title" v-text="$ml.get('pixOpenFinanceRedirect')" tabindex="0" />
                </slot>
            </div>
            <div class="openFinanceRedirect__bottom">
                <slot name="third">
                    <img src="@/assets/img/Openfinance.svg" alt="Redirecionamento Openfinance" tabindex="-1" />
                    <p class="openFinanceRedirect__text" v-text="$ml.get('pixOpenFinanceSecurityRedirect')" tabindex="0" />
                    <CieloButtonV2 v-if="!buttonClicked" class="openFinanceRedirect__customButton" @click="handleButtonClick">
                        <span v-text="$ml.get('pixOpenFinanceGoNowToBank') + ' ' + selectedBank.organizationName" />
                    </CieloButtonV2>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const CieloButtonV2 = () =>
  import(
    /* webpackChunkName: "cielo-button" */
    '@/components/template/CieloButtonV2'
  );

export default {
  components: {
    CieloButtonV2
  },
  name: 'OpenFinanceRedirect',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedBank: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonClicked: false
    };
  },
  computed: {
    ...mapGetters({
      bankRedirectUrl: 'pixOpenFinancePayment/getBankRedirectUrl'
    })
  },
  methods: {
    handleButtonClick() {
      if (this.bankRedirectUrl) {
        window.location.href = this.bankRedirectUrl;
        this.buttonClicked = true;
      } else {
        console.error('URL de redirecionamento não encontrada');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.openFinanceRedirect {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	z-index: 999;

	&__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        text-align: center;
        width: 100%;
        height: 100%;
    }

	&__content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex: 1;
	}

	&__images {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 32px;

		img {
			width: 80px;
			height: 80px;
			border-radius: 4px;
			margin-right: 10px;
		}

		img:last-child {
			margin-right: 0;
		}
	}

	&__title {
		font-size: 20px;
		font-weight: 700;
		line-height: 28px;
		color: #2F363E;

		&--loading {
			font-size: 24px;
			font-weight: 700;
			line-height: 28px;
			color: #2F363E;
		}
	}

	&__subtitle {
		&--loading {
			font-size: 16px;
			font-weight: 500;
			line-height: 24px;
			color: #454F5C;
		}
	}

	&__bottom {
		width: 100%;
        max-width: 360px;
        display: flex;
        flex-direction: column;
        align-items: center;

		img {
			margin-bottom: 16px;
		}
	}

	&__text {
		width: 100%;
		max-width: 318px;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		color: #5C6A7B;
	}

	&__customButton {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		border: 1.5px solid #0774E7;
		border-radius: 32px;

		span {
			font-size: 16px;
			font-weight: 600;
			line-height: 24px;
			color: #0774E7;
		}
	}
}
</style>
